//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockBatchList', {
//        templateUrl: 'views/components/views/stockBatchList/stockBatchList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stockBatchListService', function ($stateParams, stockBatchListService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockKeyno = $stateParams.stock_keyno;

//            vm.model = {
//                itemsListStockBatches: []
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadStockBatches() {
//                vm.model.itemsListStockBatches = await stockBatchListService.listStockBatches({ stock_keyno: stockKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadStockBatches();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
